/** Accept only a bounded, visible course query from a dashboard deep link. */
export function readPrerequisiteLaunchQuery(search: string): string {
  const value = new URLSearchParams(search).get('q') ?? '';
  if (value.length > 80 || /[\u0000-\u001f\u007f]/.test(value)) return '';
  return value.trim();
}

/** Explicit record links can open an editing tab without changing saved data. */
export function readPrerequisiteLaunchView(search: string): 'completed' | 'ap-credits' | 'checker' | null {
  const view = new URLSearchParams(search).get('view');
  return view === 'completed' || view === 'ap-credits' || view === 'checker' ? view : null;
}
